export default __webpack_public_path__ + "static/media/vip10-bg.dd616e9d.webp";